// Copyright 2017-2023 @polkadot/util authors & contributors
// SPDX-License-Identifier: Apache-2.0

import { isOnFunction } from "./helpers.js";

/**
 * @name isClass
 * Tests if the supplied agrument is a Class
 */
export const isClass = /*#__PURE__*/isOnFunction('isPrototypeOf', 'hasOwnProperty');